<template>
    <rkm-area
        type="fieldset"
        title="Cadastro"
        show-legend
    >
        <rkm-row v-if="data.form">
            <rkm-col cols="3">
                <rkm-col>
                    <rkm-form-date-picker
                        label="Data"
                        :max-date="data.form.dataAtual"
                        v-model="data.model.cadastro.dataCadastro"
                        :validations="validations.data"
                    />
                </rkm-col>
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-select
                    :options="data.form.pseId"
                    label="PSE"
                    show-default-option
                    text-field="descricao"
                    v-model="data.model.cadastro.pseId"
                    :validations="validations.pse"
                    default-option-text="Selecione"
                    value-field="id"
                    @change="handlePSE($event)"
                />
            </rkm-col>

            <rkm-col cols="1">
                <rkm-form-input
                    v-model="data.model.cadastro.inep"
                    label="INEP"
                    :validations="validations.inep"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    v-model="data.model.cadastro.localAtividade"
                    label="Outra localidade"
                    :validations="validations.localAtividade"
                    :disabled="data.model.cadastro.pseId ? true : false"
                />
            </rkm-col>

            <rkm-col cols="1">
                <rkm-form-input
                    v-model="data.model.cadastro.cnes"
                    label="CNES"
                    :disabled="data.model.cadastro.pseId ? true : false"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-select
                    :options="data.form.turnos"
                    label="Turno"
                    show-default-option
                    text-field="descricao"
                    v-model="data.model.cadastro.turnoId"
                    :validations="validations.turno"
                    default-option-text="Selecione"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
//Enums
import saudeTemas from '@/enums/atencao-basica/atividade-coletiva/saudeTema'

// Vuex.
import { mapActions } from 'vuex'

// Filters
import formats from '@/filters/formats'

// Mixins
import { repository, object } from '@/mixins'

export default {
    data: () => ({
        enums: {
            saudeTemas
        }
    }),
    computed: {
        validations() {
            return {
                data: {
                    required: true
                },
                pse: {
                    required: this.isRequiredPse
                },
                inep: {
                    max: 8,
                    required: this.isRequiredInep
                },
                localAtividade: {
                    max: 250
                },
                turno: {
                    required: true
                }
            }
        },
        isRequiredPse() {
            return this.data.model.saudeTemas.includes(this.enums.saudeTemas.SEMANA_SAUDE_NA_ESCOLA)
        },
        isRequiredInep() {
            return this.data.model.cadastro.pseId !== null ? true : false
        }
    },
    watch: {
        'data.model.cadastro.inep': function () {
            this.data.model.cadastro.localAtividade = null
            this.data.model.cadastro.cnes = null
        },
        'data.model.cadastro.localAtividade': function () {
            this.data.model.cadastro.inep = null
            this.data.model.cadastro.cnes = null
        },
        'data.model.cadastro.cnes': function () {
            this.data.model.cadastro.localAtividade = null
            this.data.model.cadastro.inep = null
        },
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handlePSE(event) {
            if(event) {
                this.data.model.cadastro.localAtividade = null
                this.data.model.cadastro.cnes = null
            }
        },
    },
    mixins: [ repository, object, formats, ],
    props: {
        data: { type: Object, required: false },
        id: { type: Number }
    },
}
</script>